import config from 'shared/config';
import Customer from 'models/Customer';
import ErrorBoundary from 'shared/components/ErrorBoundary';
import LoginContainer from 'features/User/containers/LoginContainer';
import EmailCartContainer from 'features/Cart/containers/EmailCartContainer';
import Modal from '@material-ui/core/Modal';
import overlayStyle from 'shared/materialUIFormat/overlayFormatting';
import PropTypes from 'prop-types';
import React from 'react';
import RegistrationContainer from 'features/User/containers/RegistrationContainer';
import NavAppBar from './NavAppBar';
import NavMainDrawer from './NavMainDrawer';
import NavCartDrawer from './NavCartDrawer';
import styles from '../styles.css';

const NavBar = props => {
	const {
		brandInfo,
		closeCartDrawer,
		closeLogin,
		closeMainDrawer,
		closeRegistration,
		customer,
		isCartDrawerOpen,
		isMainDrawerOpen,
		logout,
		openLogin,
		openRegistration,
		openStoreModal,
		showLogin,
		showEmailCart,
		closeEmailCart,
		openEmailCart,
		showRegistration,
		toggleCartDrawer,
		toggleMainDrawer,
		emailCartOpenLogin,
	} = props;

	return (
		<div className={styles['nav-bar']}>
			<ErrorBoundary>
				<ErrorBoundary>
					<NavAppBar
						customer={customer}
						openLogin={openLogin}
						openRegistration={openRegistration}
						logo={brandInfo.logo}
						logout={logout}
						toggleCartDrawer={toggleCartDrawer}
						toggleMainDrawer={toggleMainDrawer}
					/>
				</ErrorBoundary>
				<ErrorBoundary>
					<NavMainDrawer
						closeMainDrawer={closeMainDrawer}
						customer={customer}
						isMainDrawerOpen={isMainDrawerOpen}
						logout={logout}
						openLogin={openLogin}
						openRegistration={openRegistration}
						openStoreModal={openStoreModal}
						toggleMainDrawer={toggleMainDrawer}
						brandTopics={brandInfo.topics}
					/>
				</ErrorBoundary>
				<ErrorBoundary>
					{config.GENERAL.ShowCart ? (
						<NavCartDrawer
							closeCartDrawer={closeCartDrawer}
							customer={customer}
							isCartDrawerOpen={isCartDrawerOpen}
							toggleCartDrawer={toggleCartDrawer}
							openEmailCart={openEmailCart}
						/>
					) : null}
				</ErrorBoundary>
				<Modal
					aria-labelledby="modal-label"
					style={overlayStyle.main}
					BackdropProps={{ style: overlayStyle.backdropStyle }}
					open={showEmailCart}
					onClose={closeEmailCart}
				>
					<div style={overlayStyle.loginSection}>
						<EmailCartContainer
							closeEmailCart={closeEmailCart}
							emailCartOpenLogin={emailCartOpenLogin}
						/>
					</div>
				</Modal>
				<Modal
					aria-labelledby="modal-label"
					style={overlayStyle.main}
					BackdropProps={{ style: overlayStyle.backdropStyle }}
					open={showLogin}
					onClose={closeLogin}
				>
					<div style={overlayStyle.loginSection}>
						<LoginContainer
							closeLogin={closeLogin}
							openRegistration={openRegistration}
							logo={brandInfo.logo}
						/>
					</div>
				</Modal>
				<Modal
					aria-labelledby="modal-label"
					style={overlayStyle.main}
					BackdropProps={{ style: overlayStyle.backdropStyle }}
					open={showRegistration}
					onClose={closeRegistration}
				>
					<div style={overlayStyle.loginSection}>
						<RegistrationContainer
							closeRegistration={closeRegistration}
							openLogin={openLogin}
							logo={brandInfo.logo}
						/>
					</div>
				</Modal>
			</ErrorBoundary>
		</div>
	);
};

NavBar.propTypes = {
	brandInfo: PropTypes.shape({
		logo: PropTypes.string,
		topics: PropTypes.arrayOf(PropTypes.object),
	}).isRequired,
	closeCartDrawer: PropTypes.func.isRequired,
	closeLogin: PropTypes.func.isRequired,
	closeMainDrawer: PropTypes.func.isRequired,
	closeRegistration: PropTypes.func.isRequired,
	customer: PropTypes.instanceOf(Customer).isRequired,
	isCartDrawerOpen: PropTypes.bool,
	isMainDrawerOpen: PropTypes.bool,
	logout: PropTypes.func.isRequired,
	openLogin: PropTypes.func.isRequired,
	openRegistration: PropTypes.func.isRequired,
	openStoreModal: PropTypes.func.isRequired,
	showLogin: PropTypes.bool,
	showEmailCart: PropTypes.bool,
	openEmailCart: PropTypes.func.isRequired,
	closeEmailCart: PropTypes.func.isRequired,
	showRegistration: PropTypes.bool,
	toggleMainDrawer: PropTypes.func.isRequired,
	toggleCartDrawer: PropTypes.func.isRequired,
	emailCartOpenLogin: PropTypes.func.isRequired,
};

NavBar.defaultProps = {
	showLogin: false,
	showEmailCart: false,
	showRegistration: false,
	isMainDrawerOpen: false,
	isCartDrawerOpen: false,
};

export default NavBar;
